import React from "react"
import { UserDataDialog } from "./UserDataDialog"
import ShowMessage from "./ShowMessage"
import UserInputValueDialog from "./UserInputValueDialog"
import UserConfirmDialog from "./UserConfirmDialog"

export const UserInteractionLayer = React.memo(function () {
  return (
    <>
      <UserDataDialog />
      <ShowMessage />
      <UserInputValueDialog />
      <UserConfirmDialog />
    </>
  )
})
